import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import ColumnButton from "src/components/Page/GridButtons/ColumnButton";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import {
  deleteCalllogStatusSaga,
  getCalllogStatusDetailsSaga,
  getCalllogStatusListSaga,
} from "src/store/calllog-status/saga";
import {
  CalllogStatusDetailDto,
  CalllogStatusDto,
} from "src/store/calllog-status/type";
import CalllogStatusCreateForm from "./create";
import CalllogStatusEditForm from "./edit";
const CalllogStatusPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState<CalllogStatusDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<CalllogStatusDetailDto>();
  const columns = [
    {
      text: t("ClientCalllogStatus.Name"),
      dataField: "Name",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("ClientCalllogStatus.PageTitle")}
        metaTag={t("ClientCalllogStatus.MetaTag")}
        gridProps={{
          addTitle: t("ClientCalllogStatus.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getCalllogStatusListSaga,
          onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getCalllogStatusDetailsSaga({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          deleteButton: {
            text: (id, data: CalllogStatusDto) =>
              t("CalllogStatus.DeleteQA", {
                name: data.Name,
              }),
            action: deleteCalllogStatusSaga,
            onClick: (id, data) => setShowEdit(data),
          },
        }}
      />
      <CalllogStatusCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getCalllogStatusListSaga,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <CalllogStatusEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getCalllogStatusListSaga,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default CalllogStatusPage;
